import { useGetImpactAuditById } from '@/hooks/queries';

import { getAuditItems } from './auditEntityFinder';
import AuditViewComponent from './AuditViewComponent';
import type { AuditEntityRetrieverInput } from './types';

const ImpactAudit = (input: AuditEntityRetrieverInput) => {
  const { data: result } = useGetImpactAuditById({
    queryArgs: {
      id: input.id,
    },
  });
  const { current, previous } = getAuditItems(
    result?.impact_audit,
    input.operationDate
  );

  return (
    <AuditViewComponent
      operation={input.operation}
      current={JSON.stringify(current, null, 2)}
      previous={JSON.stringify(previous, null, 2)}
    />
  );
};

export default ImpactAudit;
